import {AuthService} from './../services/auth.service';
import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import * as $ from 'jquery';
import {RolePermissions} from './role.permissions.model';

@Component({
  selector: 'pm-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.sass']
})
export class MenuComponent implements OnInit, AfterViewInit {
  public pageTitle = 'Menu';
  public rolePermissions: RolePermissions = new RolePermissions();
  public showCatalogMenu: boolean;
  showMenu = true;

  @Output() disengageEvtEmitter: EventEmitter<boolean>;

  constructor(private auth: AuthService) {
    this.disengageEvtEmitter = new EventEmitter();
  }

  ngOnInit(): void {
    this.queryRolePermissions();
    console.log('MenuComponent: OnInit: showCatalogMenu: ', this.showCatalogMenu);
  }

  ngAfterViewInit() {
    // $.getScript('assets/assets/build/js/custom.min.js');
    // console.log('Menu:' + this.showMenu);
    $('.menu_btn').click(function () {
      if ($(this).hasClass('closed')) {
        console.log('it was opened')
        $('.main_wrapper').removeClass('menuInactive');
        $('.logo').removeClass('h_logo');
        $('.logoPrincipal').removeClass('img_none');
        $(this)
          .removeClass('closed')
          .addClass('opened');
      } else {
        console.log('it was closed')
        $('.main_wrapper').addClass('menuInactive');
        $('.logo').addClass('h_logo');
        $('.logoPrincipal').addClass('img_none');
        $(this)
          .removeClass('opened')
          .addClass('closed');
        $('.s_level').hide();
      }
      $('.btn_second')
        .next('.s_level')
        .slideToggle();
    });

    // - inicio responsive menu
    if ($(window).innerWidth() <= 960) {
      console.log('aqui 1...')
      $('.menu_btn').addClass('closed');
      $('.main_wrapper').addClass('menuInactive');
      $('.f_level a')
        .not('.btn_second')
        .on('click', function () {
          $('.menu_btn').addClass('closed');
          $('.main_wrapper').addClass('menuInactive');
        });
    }

    $(window).on('resize', function () {
      console.log('aqui 2...')
      if ($(window).innerWidth() <= 960) {
        $('.f_level a')
          .not('.btn_second')
          .on('click', function () {
            $('.menu_btn').addClass('closed');
            $('.main_wrapper').addClass('menuInactive');
          });
      } else {
        $('.f_level a')
          .not('.btn_second')
          .off('click');
      }
    });

    // - final responsive menu

    // if ($('#menu-catalogos').attr('class') === 'btns ic5 btn_second') {
    //   console.log('click on submenu');
    //   $(this)
    //     .next('.s_level')
    //     .slideToggle();
    // }

    $('.btn_second').click(function () {
      // console.log('click on btn_second');
      // $('.s_level').hide();
      // if ($('#submenu').attr('class') === 's_level') {
      //   console.log('click on submenu');
      //   $(this)
      //     .next('.s_level')
      //     .slideToggle();
      // } else {
      //   console.log('click on menu');
      // }
      $(this)
        .next('.s_level')
        .slideToggle();
    });

    /* $('.f_level > li > a')
      .not('.btn_second')
      .click(function() {
        $('.s_level')
        .hide();
      }); */


  }

  toggleImage(): void {
    console.log(this.showMenu);
  }

  queryRolePermissions(): void {
    console.log('MenuComponent: queryRolePermissions: isLoggedIn: ', this.auth.isLoggedIn());
    this.rolePermissions = JSON.parse(localStorage.getItem('rolePermissions')) as RolePermissions;
    console.log('MenuComponent: queryRolePermissions: rolePermissions: ', this.rolePermissions);
    if (this.rolePermissions && this.auth.isLoggedIn()) {
      if (
        this.rolePermissions.binCatalog ||
        this.rolePermissions.cardBrandCatalog ||
        this.rolePermissions.cardIssuerCatalog ||
        this.rolePermissions.merchantCatalog ||
        this.rolePermissions.posCatalog
      ) {
        this.showCatalogMenu = true;
      }
    }
  }

  disengage() {
    console.log('Emitting event from menu...');
    this.disengageEvtEmitter.emit(false);
  }
}
